import * as React from 'react';
import styled from 'styled-components';
import { Flex } from '../compositeComponents/FlexHelpers';
import { Divider } from '../Divider';

type LayoutProps = {
    header:React.ReactNode,
    content:React.ReactNode,
    noDivider?:boolean
}
export function Layout(props:LayoutProps):JSX.Element
{
    return (
        <Wrapper>
            <Flex flexDirection="column" gap={32}>
                {props.header}
                {!props.noDivider &&
                    <Divider />
                }
                {props.content}
            </Flex>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width:100%;
    margin: 32px auto 0px auto;
    max-width: 1020px;
    padding:0px 10px;
`;
